import { render, staticRenderFns } from "./ProductVideoComponent.vue?vue&type=template&id=7d767890"
import script from "./ProductVideoComponent.vue?vue&type=script&lang=js"
export * from "./ProductVideoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports